import React, { useEffect, useState } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import { Select2Nolabel } from "view/component/FormFormik";
import SkriningArea from "view/Grafik/SkriningArea";
import apiService from "apiService";
import { toast } from "view/component/Alert";
const styles = {
  container: {
    backgroundColor: "#CFF4F0", // Light blue background
    padding: "10px", // Add some padding
    display: "flex",
    justifyContent: "center", // Center the text horizontally
    alignItems: "center", // Center the text vertically
  },
  text: {
    transform: "rotate(180deg)", // Rotate the text vertically
    transformOrigin: "center", // Ensure proper alignment of the rotation
    writingMode: "vertical-rl", // Alternative way to make vertical text
    textAlign: "center", // Center-align the text
    fontSize: "14px", // Adjust font size
    color: "#333", // Text color
  },
};
const formatNumber = (number) => {
  if (isNaN(number)) return "0"; // Handle invalid numbers
  return number.toLocaleString("en-US").replace(/,/g, "."); // Replace commas with dots
};

const IlpDashboard = () => {
  const [workArea, setworkArea] = useState([]);
  const [skrining_list, setSkrininglist] = useState([]);
  const [screening_id, setSkrining] = useState();

  const [area, setarea] = useState([]);
  const [loading, setloading] = useState(false);
  const [ds, setds] = useState(null);
  const [ds_wilayah, setds_wilayah] = useState();
  const [ds_kecamatan, setds_kecamatan] = useState();
  const [ds_puskesmas, setds_puskesmas] = useState();

  const [kecamatans, setKecamatans] = useState([]);
  const [refKecamatan, setRefKecamatan] = useState([]);
  const userLevel = JSON.parse(localStorage.getItem("userData")).level;
  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-toggle="tooltip"]')
    );
    tooltipTriggerList.map(
      (tooltipTriggerEl) => new window.bootstrap.Tooltip(tooltipTriggerEl)
    );
  }, []);

  const getDistrict = async () => {
    const res = await apiService.get("/demograph/cities/find/3404");
    if (res?.code === 200) {
      setRefKecamatan(res.data.districts);
    }
  };

  useEffect(() => {
    if (userLevel != 1) {
      getWorkArea();
    } else {
      getDistrict();
    }
    searchIlpReport();
  }, [1]);
  const getWorkArea = async () => {
    const work_areas = await apiService.get(`/management/work_areas/read`);
    let d = [];
    if (work_areas) {
      setworkArea(work_areas.data);
      work_areas.data.map((a) => {
        d.push({ label: a.village.name, value: a.village_id });
      });
      setarea(d);
    } else {
      setworkArea([]);
    }
  };

  const searchIlpReport = async () => {
    const response = await apiService.get("ilp/list_screening");
    let dt = [];
    if (response) {
      if (response?.code !== 200) {
        toast({ status: "error", text: response?.status });
        dt = [];
      } else {
        dt = response.data;
      }
      setSkrininglist(dt);
    }
  };

  const getDashboard = async () => {
    let area_id = area.map((a) => a.value);
    let param = {
      area: area_id,
      screening_id: screening_id,
    };
    const res = await apiService.post(`/ilp/get_report_dashboard`, param);
    if (res.code == 200) {
      setds(res.data);
    } else {
      setds([]);
    }
  };

  const getDashboardArea = async () => {
    let area_id = area.map((a) => a.value);
    let param = {
      area: area_id,
      screening_id: screening_id,
    };
    const res = await apiService.post(
      `/ilp/get_report_dashboard_wilayah`,
      param
    );
    if (res.code == 200) {
      setds_wilayah(res.data);
    } else {
      setds_wilayah(null);
    }
  };

  const getDashboardKecamatan = async () => {
    let area_id = area.map((a) => a.value);
    let param = {
      area: area_id,
      screening_id: screening_id,
    };
    const res = await apiService.post(
      `/ilp/get_report_dashboard_kecamatan`,
      param
    );
    if (res.code == 200) {
      setds_kecamatan(res.data);
    } else {
      setds_kecamatan(null);
    }
  };

  const getDashboardPuskesmas = async () => {
    let area_id = area.map((a) => a.value);
    let param = {
      area: area_id,
      screening_id: screening_id,
    };
    const res = await apiService.post(
      `/ilp/get_report_dashboard_puskesmas`,
      param
    );
    if (res.code == 200) {
      setds_puskesmas(res.data);
    } else {
      setds_puskesmas(null);
    }
  };

  useEffect(() => {
    getDashboard();
    if (userLevel == 1) {
      getDashboardPuskesmas();
      getDashboardKecamatan();
    }
    getDashboardArea();
  }, [area, screening_id]);

  useEffect(() => {
    if (userLevel == 1 && kecamatans) {
      let dt = [];
      for (let index = 0; index < kecamatans.length; index++) {
        const element = kecamatans[index];
        dt.push(...element.villages);
      }
      console.log(dt);
      setworkArea(dt);
    }
  }, [kecamatans]);

  return (
    <div>
      <div className=" card ml-2 mr-2 bg-white">
        <div
          style={{ ...styles.container, backgroundColor: "whitesmoke" }}
          className="card"
        >
          <h4>RINGKASAN PELAKSANAAN SKRINING BERDASARKAN USIA </h4>
          <small>Jumlah Pasien Merupakan Pasien Berjalan Pada Tahun ini</small>
        </div>
        <div className="row ml-2">
          <div className="card col-md-6">
            <div className="card-body">
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-pink col-md-8 ">
                  <div className="checklist-info">
                    <h3 className="checklist-title mb-0">Total Individu</h3>
                    <h1>
                      {formatNumber(
                        ds?.total[0]?.jumlah ? ds?.total[0]?.jumlah : 0
                      )}
                    </h1>
                    <small>
                      Kunjungan Merupakan Kunjungan Pasien sampai hari ini
                    </small>
                  </div>
                </div>
                <div className="col-md-3">
                  <CircularProgressbar
                    value={100}
                    text={`100%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
          <div className="col-md-5 card ml-1">
            <div className="form-group col-md-12 row">
              {userLevel == 1 ? (
                <>
                  <label
                    htmlFor="example-text-input"
                    className="col-md-4 col-form-label col-form-label-sm"
                  >
                    Kecamatan
                  </label>
                  <div className="col-md-8">
                    <div className="row">
                      <Select2Nolabel
                        className="basic-multi-select form-control  p-0 pt-1 col-md-12"
                        name="kecamatan"
                        onChange={(e) => setKecamatans(e)}
                        value={kecamatans}
                        errors={""}
                        touched={""}
                        icon="ni ni-circle-08"
                        type="text"
                        option={refKecamatan.map((district) => ({
                          label: district.name,
                          value: district.id,
                          villages: district.villages,
                        }))}
                        isMulti
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <label
                htmlFor="example-text-input"
                className="col-md-4 col-form-label col-form-label-sm"
              >
                Desa
              </label>
              <div className="col-md-8">
                <div className="row">
                  <Select2Nolabel
                    className="basic-multi-select form-control  p-0 pt-1 col-md-12"
                    name="village"
                    onChange={(e) => setarea(e)}
                    value={area}
                    errors={""}
                    touched={""}
                    icon="ni ni-circle-08"
                    type="text"
                    option={workArea.map((a) => ({
                      label: a.village ? a.village.name : a.name,
                      value: a.village_id ? a.village_id : a.id,
                    }))}
                    isMulti
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ml-2">
          <div className="card" style={styles.container}>
            <span style={styles.text}>
              {" "}
              <b>Usia 0 - 59 bulan</b>
            </span>
          </div>
          <div className="card col-md-3">
            <div className="row mt-2">
              <h5 className="col-md-5 ml-2 checklist-title mb-0">Bayi</h5>
              <div
                className="nav-link nav-link-icon col-md-6"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="0-11 Bulan"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-info col-md-5 ">
                  <div className="checklist-info">
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit?.Bayi ? ds?.data_visit?.Bayi : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening?.Bayi ? ds?.data_screening?.Bayi : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.Bayi || ds?.data_visit?.Bayi != 0
                        ? ((ds?.data_screening?.Bayi ?? 0) /
                            (ds?.data_visit?.Bayi ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.Bayi || ds?.data_visit?.Bayi != 0
                        ? Math.round(
                            ((ds?.data_screening?.Bayi ?? 0) /
                              (ds?.data_visit?.Bayi ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening?.Bayi ?? 0) /
                                  (ds?.data_visit?.Bayi ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
          <div className="card col-md-3 ml-2">
            <div className="row mt-2">
              <h5 className="col-md-5 ml-2 checklist-title mb-0">Baduta</h5>
              <div
                className="nav-link nav-link-icon col-md-6"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="12-23 Bulan"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-info col-md-6 ">
                  <div className="checklist-info">
                    {/* <h5 className="checklist-title mb-0">Baduta</h5> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit?.Baduta ? ds?.data_visit?.Baduta : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening?.Baduta
                        ? ds?.data_screening?.Baduta
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.Baduta || ds?.data_visit?.Baduta != 0
                        ? ((ds?.data_screening?.Baduta ?? 0) /
                            (ds?.data_visit?.Baduta ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.Baduta || ds?.data_visit?.Baduta != 0
                        ? Math.round(
                            ((ds?.data_screening?.Baduta ?? 0) /
                              (ds?.data_visit?.Baduta ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening?.Baduta ?? 0) /
                                  (ds?.data_visit?.Baduta ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
          <div className="card col-md-3 ml-2">
            <div className="row mt-2">
              <h5 className="col-md-5 ml-2 checklist-title mb-0">Balita</h5>
              <div
                className="nav-link nav-link-icon col-md-6"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="12-59 Bulan"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-info col-md-6 ">
                  <div className="checklist-info">
                    {/* <h5 className="checklist-title mb-0">Balita</h5> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit?.Balita ? ds?.data_visit?.Balita : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening?.Balita
                        ? ds?.data_screening?.Balita
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.Balita || ds?.data_visit?.Balita != 0
                        ? ((ds?.data_screening?.Balita ?? 0) /
                            (ds?.data_visit?.Balita ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.Balita || ds?.data_visit?.Balita != 0
                        ? Math.round(
                            ((ds?.data_screening?.Balita ?? 0) /
                              (ds?.data_visit?.Balita ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening?.Balita ?? 0) /
                                  (ds?.data_visit?.Balita ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
        </div>
        <div className="row ml-2">
          <div className="card" style={styles.container}>
            <span style={styles.text}>
              <b>Usia 5 - 17 Tahun</b>
            </span>
          </div>
          <div className="card col-md-3">
            <div className="row mt-2">
              <h5 className="col-md-8 ml-2 checklist-title mb-0">
                {" "}
                Anak Usia Pra Sekolah
              </h5>
              <div
                className="nav-link nav-link-icon col-md-3"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="60-72 Bulan"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-primary col-md-6 ">
                  <div className="checklist-info">
                    {/* <h5 className="checklist-title mb-0">
                      Anak Usia Pra Sekolah
                    </h5> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit["Pra Sekolah"]
                        ? ds?.data_visit["Pra Sekolah"]
                        : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening["Pra Sekolah"]
                        ? ds?.data_screening["Pra Sekolah"]
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.["Pra Sekolah"] ||
                      ds?.data_visit?.["Pra Sekolah"] != 0
                        ? ((ds?.data_screening["Pra Sekolah"] ?? 0) /
                            (ds?.data_visit["Pra Sekolah"] ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.["Pra Sekolah"] ||
                      ds?.data_visit?.["Pra Sekolah"] != 0
                        ? Math.round(
                            ((ds?.data_screening["Pra Sekolah"] ?? 0) /
                              (ds?.data_visit["Pra Sekolah"] ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening["Pra Sekolah"] ?? 0) /
                                  (ds?.data_visit["Pra Sekolah"] ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
          <div className="card col-md-3 ml-2">
            <div className="row mt-2">
              <h5 className="col-md-8 ml-2 checklist-title mb-0">
                Anak Usia Sekolah
              </h5>
              <div
                className="nav-link nav-link-icon col-md-3"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="6-7 Tahun"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-primary col-md-6 ">
                  <div className="checklist-info">
                    {/* <h5 className="checklist-title mb-0">Anak Usia Sekolah</h5> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit?.Sekolah ? ds?.data_visit?.Sekolah : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening?.Sekolah
                        ? ds?.data_screening?.Sekolah
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.Sekolah || ds?.data_visit?.Sekolah != 0
                        ? ((ds?.data_screening?.Sekolah ?? 0) /
                            (ds?.data_visit?.Sekolah ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.Sekolah || ds?.data_visit?.Sekolah != 0
                        ? Math.round(
                            ((ds?.data_screening?.Sekolah ?? 0) /
                              (ds?.data_visit?.Sekolah ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening?.Sekolah ?? 0) /
                                  (ds?.data_visit?.Sekolah ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
        </div>
        <div className="row ml-2">
          <div className="card" style={styles.container}>
            <span style={styles.text}>
              <b>Usia 10 - 17 Tahun</b>
            </span>
          </div>
          <div className="card col-md-3">
            <div className="row mt-2">
              <h5 className="col-md-5 ml-2 checklist-title mb-0">Remaja</h5>
              <div
                className="nav-link nav-link-icon col-md-6"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="10-17 Tahun"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-purple col-md-6 ">
                  <div className="checklist-info">
                    {/* <h5 className="checklist-title mb-0">Remaja</h5> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit?.Remaja ? ds?.data_visit?.Remaja : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening?.Remaja
                        ? ds?.data_screening?.Remaja
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.Remaja || ds?.data_visit?.Remaja != 0
                        ? ((ds?.data_screening?.Remaja ?? 0) /
                            (ds?.data_visit?.Remaja ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.Remaja || ds?.data_visit?.Remaja != 0
                        ? Math.round(
                            ((ds?.data_screening?.Remaja ?? 0) /
                              (ds?.data_visit?.Remaja ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening?.Remaja ?? 0) /
                                  (ds?.data_visit?.Remaja ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
          <div className="card col-md-3 ml-2">
            <div className="row mt-2">
              <h5 className="col-md-5 ml-2 checklist-title mb-0">
                Remaja Wanita
              </h5>
              <div
                className="nav-link nav-link-icon col-md-6"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="10-17 Tahun Berjenis Kelamin Perempuan"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-purple col-md-6 ">
                  <div className="checklist-info">
                    {/* <h5 className="checklist-title mb-0">Remaja Wanita</h5> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit["Remaja Wanita"]
                        ? ds?.data_visit["Remaja Wanita"]
                        : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening["Remaja Wanita"]
                        ? ds?.data_screening["Remaja Wanita"]
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.["Remaja Wanita"] ||
                      ds?.data_visit?.["Remaja Wanita"] != 0
                        ? ((ds?.data_screening["Remaja Wanita"] ?? 0) /
                            (ds?.data_visit["Remaja Wanita"] ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.["Remaja Wanita"] ||
                      ds?.data_visit?.["Remaja Wanita"] != 0
                        ? Math.round(
                            ((ds?.data_screening["Remaja Wanita"] ?? 0) /
                              (ds?.data_visit["Remaja Wanita"] ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening["Remaja Wanita"] ?? 0) /
                                  (ds?.data_visit["Remaja Wanita"] ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
        </div>
        <div className="row ml-2">
          <div className="card" style={styles.container}>
            <span style={styles.text}>
              <b>Usia 18 - 59 Tahun</b>
            </span>
          </div>
          <div className="card col-md-3">
            <div className="row mt-2">
              <h5 className="col-md-5 ml-2 checklist-title mb-0">Dewasa</h5>
              <div
                className="nav-link nav-link-icon col-md-6"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="18-59 Tahun"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-purple col-md-6 ">
                  <div className="checklist-info">
                    {/* <h5 className="checklist-title mb-0">Dewasa</h5> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit?.Dewasa ? ds?.data_visit?.Dewasa : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening?.Dewasa
                        ? ds?.data_screening?.Dewasa
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.Dewasa || ds?.data_visit?.Dewasa != 0
                        ? ((ds?.data_screening?.Dewasa ?? 0) /
                            (ds?.data_visit?.Dewasa ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.Dewasa || ds?.data_visit?.Dewasa != 0
                        ? Math.round(
                            ((ds?.data_screening?.Dewasa ?? 0) /
                              (ds?.data_visit?.Dewasa ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening?.Dewasa ?? 0) /
                                  (ds?.data_visit?.Dewasa ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
          <div className="card col-md-3 ml-2">
            <div className="row mt-2">
              <h5 className="col-md-5 ml-2 checklist-title mb-0">Hamil</h5>
              <div
                className="nav-link nav-link-icon col-md-6"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="Hamil"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-pink col-md-6 ">
                  <div className="checklist-info">
                    {/* <h3 className="checklist-title mb-0">Kehamilan</h3> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit?.Hamil ? ds?.data_visit?.Hamil : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening?.Hamil
                        ? ds?.data_screening?.Hamil
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.Hamil || ds?.data_visit?.Hamil != 0
                        ? ((ds?.data_screening?.Hamil ?? 0) /
                            (ds?.data_visit?.Hamil ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.Hamil || ds?.data_visit?.Hamil != 0
                        ? Math.round(
                            ((ds?.data_screening?.Hamil ?? 0) /
                              (ds?.data_visit?.Hamil ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening?.Hamil ?? 0) /
                                  (ds?.data_visit?.Hamil ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
        </div>

        <div className="row ml-2">
          <div className="card" style={styles.container}>
            <span style={styles.text}>
              <b>Usia > 60 Tahun</b>
            </span>
          </div>
          <div className="card col-md-3">
            <div className="row mt-2">
              <h5 className="col-md-5 ml-2 checklist-title mb-0">Lansia</h5>
              <div
                className="nav-link nav-link-icon col-md-6"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title=">= 60 Tahun"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-purple col-md-6 ">
                  <div className="checklist-info">
                    {/* <h5 className="checklist-title mb-0">Lansia</h5> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit?.Lansia ? ds?.data_visit?.Lansia : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening?.Lansia
                        ? ds?.data_screening?.Lansia
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.Lansia || ds?.data_visit?.Lansia != 0
                        ? ((ds?.data_screening?.Lansia ?? 0) /
                            (ds?.data_visit?.Lansia ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.Lansia || ds?.data_visit?.Lansia != 0
                        ? Math.round(
                            ((ds?.data_screening?.Lansia ?? 0) /
                              (ds?.data_visit?.Lansia ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening?.Lansia ?? 0) /
                                  (ds?.data_visit?.Lansia ?? 0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
          <div className="card col-md-3 ml-2">
            <div className="row mt-2">
              <h5 className="col-md-9 ml-2 checklist-title mb-0">
                Lansia Risiko Tinggi
              </h5>
              <div
                className="nav-link nav-link-icon col-md-2"
                rel="noopener noreferrer"
                data-toggle="tooltip"
                data-original-title="> 70 Tahun"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <i className="fa fa-info-circle"></i>
              </div>
            </div>
            <div className="card-body">
              {/* <ul className="list-group list-group-flush"> */}
              {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
              <div className="row">
                {/* <ul className="list-group list-group-flush"> */}
                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4"> */}
                <div className="checklist-item checklist-item-purple col-md-6 ">
                  <div className="checklist-info">
                    {/* <h5 className="checklist-title mb-0">
                      Lansia Risiko Tinggi
                    </h5> */}
                    <small>
                      Kunjungan :{" "}
                      {ds?.data_visit["Lansia Resiko Tinggi"]
                        ? ds?.data_visit["Lansia Resiko Tinggi"]
                        : 0}
                    </small>{" "}
                    <br />
                    <small>
                      Skrining :{" "}
                      {ds?.data_screening["Lansia Resiko Tinggi"]
                        ? ds?.data_screening["Lansia Resiko Tinggi"]
                        : 0}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <CircularProgressbar
                    value={
                      ds?.data_visit?.["Lansia Resiko Tinggi"] ||
                      ds?.data_visit?.["Lansia Resiko Tinggi"] != 0
                        ? ((ds?.data_screening["Lansia Resiko Tinggi"] ?? 0) /
                            (ds?.data_visit["Lansia Resiko Tinggi"] ?? 0)) *
                          100
                        : 0
                    }
                    text={`${
                      ds?.data_visit?.["Lansia Resiko Tinggi"] ||
                      ds?.data_visit?.["Lansia Resiko Tinggi"] != 0
                        ? Math.round(
                            ((ds?.data_screening["Lansia Resiko Tinggi"] ?? 0) /
                              (ds?.data_visit["Lansia Resiko Tinggi"] ?? 0)) *
                              100 >
                              100
                              ? 100
                              : ((ds?.data_screening["Lansia Resiko Tinggi"] ??
                                  0) /
                                  (ds?.data_visit["Lansia Resiko Tinggi"] ??
                                    0)) *
                                  100
                          ) ?? 0
                        : 0
                    }%`}
                    styles={{
                      path: {
                        stroke: "#ff910e",
                      },
                      trail: {
                        stroke: "#EEEEEE",
                      },
                      text: {
                        fill: "#ff910e",
                        fontWeight: "bold",
                        fontsize: "9px",
                        dominantBaseline: "right",
                        textAnchor: "middle",
                        transform: "translate(4%, 5%)",
                      },
                    }}
                    strokeWidth={12}
                  />
                </div>
              </div>
              {/* </li> */}
              {/* </ul> */}
            </div>
          </div>
        </div>

        <div className="card col-md-11">
          <div className="card-body">
            <div className="row">
              <div className="form-group col-md-12 row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-3 col-form-label col-form-label-sm"
                >
                  Jenis Screening
                </label>
                <div className="col-md-9">
                  <div className="row">
                    <select
                      className="form-control form-control-sm col-md-12"
                      name="pregnant_status"
                      onChange={(e) => setSkrining(e.target.value)}
                    >
                      <option value="-">pilih</option>
                      {skrining_list.map((a) => (
                        <option value={a.id}>{a.screening_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card col-md-10 ml-2">
          <div className="card-header">
            <SkriningArea
              data={ds_wilayah}
              judul="Grafik Pelaksanaan Skrining Per Desa"
              skala="Desa"
              tahun={2024}
            />
          </div>
        </div>
        {/* buat dinas */}
        {userLevel == 1 ? (
          <>
            <div className="card col-md-10 ml-2">
              <div className="card-header">
                <SkriningArea
                  data={ds_kecamatan}
                  skala="Kecamatan"
                  judul="Grafik Pelaksanaan Skrining Per Kecamatan"
                  tahun={2024}
                />
              </div>
            </div>

            <div className="card col-md-10 ml-2">
              <div className="card-header">
                <SkriningArea
                  data={ds_puskesmas}
                  skala="Puskesmas"
                  judul="Grafik Pelaksanaan Skrining Per Puskesmas"
                  tahun={2024}
                />
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default IlpDashboard;
